export default ({ res }: Context) => {
  if (!process.server) return;

  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control#directives
  res.setHeader('Cache-Control', 'no-cache');
};
